import React from "react";
import "../../App.css";
import HeroSection from "../HeroSection";
import Welcome from "../Welcome";

function Home() {
  return (
    <>
      <HeroSection />
      <Welcome />
    </>
  );
}

export default Home;
